// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.buy_a_vehicle_card[data-v-2bafd389] {
  padding: 0 5px;
}
.buy_a_vehicle_card img[data-v-2bafd389] {
  height: 200px;
  display: block;
  margin: auto;
}
.buy_a_vehicle_card h5[data-v-2bafd389] {
  font-size: 0.8vw;
  font-weight: 600;
}
.buy_a_vehicle_card .ft-small[data-v-2bafd389] {
  font-size: 0.75vw;
}
.buy_a_vehicle_card .opacity-7[data-v-2bafd389] {
  opacity: 0.7;
}
.buy_a_vehicle_card .color_selector[data-v-2bafd389] {
  width: 0.7vw;
  height: 0.7vw;
  border-radius: 50%;
  display: inline-block;
  margin-right: 5px;
  position: relative;
  top: -1px;
  vertical-align: text-bottom;
}
.buy_a_vehicle_card .table-borderless > tbody > tr > td[data-v-2bafd389],
.buy_a_vehicle_card .table-borderless > tbody > tr > th[data-v-2bafd389],
.buy_a_vehicle_card .table-borderless > tfoot > tr > td[data-v-2bafd389],
.buy_a_vehicle_card .table-borderless > tfoot > tr > th[data-v-2bafd389],
.buy_a_vehicle_card .table-borderless > thead > tr > td[data-v-2bafd389],
.buy_a_vehicle_card .table-borderless > thead > tr > th[data-v-2bafd389] {
  border: none;
  padding: 5px;
  font-size: 0.73vw;
  font-weight: 500;
}
.buy_a_vehicle_card table.table-borderless tr td[data-v-2bafd389] {
  max-width: 0;
}
.buy_a_vehicle_card table.table-borderless tr td[data-v-2bafd389]:first-child {
  opacity: 0.6;
}
.border_right[data-v-2bafd389] {
  display: block;
  width: 100%;
  height: 2px;
  background: #eee;
  position: relative;
  top: 2px;
}
.custom_legend[data-v-2bafd389] {
  font-size: 0.8vw;
  font-weight: bold;
}
.animate_bottom[data-v-2bafd389] {
  animation: animateBottom-2bafd389 2s;
  transition: 0.5s;
}
.disclaimer[data-v-2bafd389] {
  text-decoration: underline;
  cursor: pointer;
  font-size: 0.73vw;
}
@keyframes animateBottom-2bafd389 {
0% {
    transform: translateY(50px);
}
100% {
    transform: translateY(0);
}
}
.max-auto-width[data-v-2bafd389] {
  max-width: fit-content;
}
.max-100[data-v-2bafd389] {
  max-width: 100px;
}
`, "",{"version":3,"sources":["webpack://./src/Components/ChatWidget/SlideOutPanel/TvmSlideOutBuyVehicle/TvmNewVehicle.vue","webpack://./TvmNewVehicle.vue"],"names":[],"mappings":"AACA;EACE,cAAA;ACAF;ADDA;EAII,aAAA;EACA,cAAA;EACA,YAAA;ACAJ;ADNA;EAUI,gBAAA;EACA,gBAAA;ACDJ;ADVA;EAeI,iBAAA;ACFJ;ADbA;EAmBI,YAAA;ACHJ;ADhBA;EAuBI,YAAA;EACA,aAAA;EACA,kBAAA;EACA,qBAAA;EACA,iBAAA;EACA,kBAAA;EACA,SAAA;EACA,2BAAA;ACJJ;AD1BA;;;;;;EAuCI,YAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;ACLJ;ADrCA;EA8CI,YAAA;ACNJ;ADxCA;EAkDI,YAAA;ACPJ;ADWA;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,QAAA;ACTF;ADYA;EACE,gBAAA;EACA,iBAAA;ACVF;ADaA;EACE,oCAAA;EACA,gBAAA;ACXF;ADcA;EACE,0BAAA;EACA,eAAA;EACA,iBAAA;ACZF;ADeA;AACE;IACE,2BAAA;ACbF;ADgBA;IACE,wBAAA;ACdF;AACF;ADiBA;EACE,sBAAA;ACfF;ADkBA;EACE,gBAAA;AChBF","sourcesContent":["\n.buy_a_vehicle_card {\n  padding: 0 5px;\n\n  img {\n    height: 200px;\n    display: block;\n    margin: auto;\n  }\n\n  h5 {\n    font-size: 0.8vw;\n    font-weight: 600;\n  }\n\n  .ft-small {\n    font-size: 0.75vw;\n  }\n\n  .opacity-7 {\n    opacity: 0.7;\n  }\n\n  .color_selector {\n    width: 0.7vw;\n    height: 0.7vw;\n    border-radius: 50%;\n    display: inline-block;\n    margin-right: 5px;\n    position: relative;\n    top: -1px;\n    vertical-align: text-bottom;\n  }\n\n  .table-borderless>tbody>tr>td,\n  .table-borderless>tbody>tr>th,\n  .table-borderless>tfoot>tr>td,\n  .table-borderless>tfoot>tr>th,\n  .table-borderless>thead>tr>td,\n  .table-borderless>thead>tr>th {\n    border: none;\n    padding: 5px;\n    font-size: 0.73vw;\n    font-weight: 500;\n  }\n\n  table.table-borderless tr td {\n    max-width: 0;\n  }\n\n  table.table-borderless tr td:first-child {\n    opacity: 0.6;\n  }\n}\n\n.border_right {\n  display: block;\n  width: 100%;\n  height: 2px;\n  background: #eee;\n  position: relative;\n  top: 2px;\n}\n\n.custom_legend {\n  font-size: 0.8vw;\n  font-weight: bold;\n}\n\n.animate_bottom {\n  animation: animateBottom 2s;\n  transition: 0.5s;\n}\n\n.disclaimer {\n  text-decoration: underline;\n  cursor: pointer;\n  font-size: 0.73vw;\n}\n\n@keyframes animateBottom {\n  0% {\n    transform: translateY(50px);\n  }\n\n  100% {\n    transform: translateY(0);\n  }\n}\n\n.max-auto-width {\n  max-width: fit-content;\n}\n\n.max-100 {\n  max-width: 100px;\n}\n",".buy_a_vehicle_card {\n  padding: 0 5px;\n}\n.buy_a_vehicle_card img {\n  height: 200px;\n  display: block;\n  margin: auto;\n}\n.buy_a_vehicle_card h5 {\n  font-size: 0.8vw;\n  font-weight: 600;\n}\n.buy_a_vehicle_card .ft-small {\n  font-size: 0.75vw;\n}\n.buy_a_vehicle_card .opacity-7 {\n  opacity: 0.7;\n}\n.buy_a_vehicle_card .color_selector {\n  width: 0.7vw;\n  height: 0.7vw;\n  border-radius: 50%;\n  display: inline-block;\n  margin-right: 5px;\n  position: relative;\n  top: -1px;\n  vertical-align: text-bottom;\n}\n.buy_a_vehicle_card .table-borderless > tbody > tr > td,\n.buy_a_vehicle_card .table-borderless > tbody > tr > th,\n.buy_a_vehicle_card .table-borderless > tfoot > tr > td,\n.buy_a_vehicle_card .table-borderless > tfoot > tr > th,\n.buy_a_vehicle_card .table-borderless > thead > tr > td,\n.buy_a_vehicle_card .table-borderless > thead > tr > th {\n  border: none;\n  padding: 5px;\n  font-size: 0.73vw;\n  font-weight: 500;\n}\n.buy_a_vehicle_card table.table-borderless tr td {\n  max-width: 0;\n}\n.buy_a_vehicle_card table.table-borderless tr td:first-child {\n  opacity: 0.6;\n}\n.border_right {\n  display: block;\n  width: 100%;\n  height: 2px;\n  background: #eee;\n  position: relative;\n  top: 2px;\n}\n.custom_legend {\n  font-size: 0.8vw;\n  font-weight: bold;\n}\n.animate_bottom {\n  animation: animateBottom 2s;\n  transition: 0.5s;\n}\n.disclaimer {\n  text-decoration: underline;\n  cursor: pointer;\n  font-size: 0.73vw;\n}\n@keyframes animateBottom {\n  0% {\n    transform: translateY(50px);\n  }\n  100% {\n    transform: translateY(0);\n  }\n}\n.max-auto-width {\n  max-width: fit-content;\n}\n.max-100 {\n  max-width: 100px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
